import React from "react";
import { Button, ButtonVariant } from "@wattpad/web-ui-library";
import { useTrans } from "../../../hooks";
import PropTypes from "prop-types";
import { FORM_VIEW } from "../constants";

const ButtonLabel = ({ action }) => {
  const { trans } = useTrans();

  return action === "login"
    ? trans("Don't have an account? Sign up")
    : trans("Already have an account? Log in");
};

export const SwitchAuthenticationActionButton = ({
  action,
  setAuthFormView = () => {}
}) => {
  return (
    <Button
      className="switch-view-button"
      variant={ButtonVariant.LINK}
      onClick={() => {
        setAuthFormView(FORM_VIEW.LOGIN);
      }}
      label={<ButtonLabel action={action} />}
      fullWidth
    />
  );
};

SwitchAuthenticationActionButton.propTypes = {
  action: PropTypes.oneOf(["login", "signup"]),
  setAuthFormView: PropTypes.func
};
